
import { Component, Emit } from "vue-property-decorator";
import { namespace } from "vuex-class";
import MobileInfoWindow from "@/components/mobile/core/MobileInfoWindow.vue";
import { FilteredEvent } from "@/store/eventqueue/types";

const Eventqueue = namespace("eventqueue");

@Component
export default class MobileEventInfoWindow extends MobileInfoWindow {
	
	@Emit("closeInfoWindow")
	private closeInfoWindow() {}

    @Eventqueue.Getter("getFilteredEvents") getFilteredEvents!: FilteredEvent[];

	private title = "";
	private subtitle = "";

	private setInfoWindowTitle(event: FilteredEvent) {
		this.title = event.displayTitle;
        this.subtitle = event.groupTitle;
	}

	public async openInfoWindow(eventId: number) {
		
        let event = this.getFilteredEvents.find(c => c.eventID == eventId)
		this.setInfoWindowTitle(event);
	}
}
